import * as React from 'react'

export const TruckIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11 1.5H2C1.71875 1.5 1.5 1.75 1.5 2V11C1.5 11.2812 1.71875 11.5 2 11.5H2.375C2.90625 10.625 3.875 10 5 10C6.09375 10 7.0625 10.625 7.59375 11.5H10H11C11.25 11.5 11.5 11.2812 11.5 11V2C11.5 1.75 11.25 1.5 11 1.5ZM12 13H11.75H11H10H8C8 14.6562 6.65625 16 5 16C3.34375 16 2 14.6562 2 13C0.875 13 0 12.125 0 11V2C0 0.90625 0.875 0 2 0H11C12.0938 0 13 0.90625 13 2V3H14.3125C14.7812 3 15.2188 3.1875 15.5625 3.53125L18.4688 6.4375C18.8125 6.78125 19 7.21875 19 7.6875V11.5H19.25C19.6562 11.5 20 11.8438 20 12.25C20 12.6875 19.6562 13 19.25 13H18C18 14.6562 16.6562 16 15 16C13.3438 16 12 14.6562 12 13ZM17.4062 7.5L14.5 4.59375C14.4688 4.53125 14.375 4.5 14.3125 4.5H13V7.5H17.4375H17.4062ZM3.5 13C3.5 13.5625 3.78125 14.0312 4.25 14.3125C4.6875 14.5938 5.28125 14.5938 5.75 14.3125C6.1875 14.0312 6.5 13.5625 6.5 13C6.5 12.4688 6.1875 12 5.75 11.7188C5.28125 11.4375 4.6875 11.4375 4.25 11.7188C3.78125 12 3.5 12.4688 3.5 13ZM15 11.5C14.4375 11.5 13.9688 11.8125 13.6875 12.25C13.4062 12.7188 13.4062 13.3125 13.6875 13.75C13.9688 14.2188 14.4375 14.5 15 14.5C15.5312 14.5 16 14.2188 16.2812 13.75C16.5625 13.3125 16.5625 12.7188 16.2812 12.25C16 11.8125 15.5312 11.5 15 11.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
